import { State } from './first-steps.reducer';

export const defaultFirstStepsFlow: State[] = ['web-call-init', 'web-call-installation', 'numbers'];

export const firstStepsConfigurationSteps: RegExp[] = [/^web-call.*/, /^numbers$/];

export const desktopOnlyConfigurationSteps: RegExp[] = [/^web-call.*/];

export const firstStateForMobile = (flow: State[]): State => {
  return flow.find(state => !desktopOnlyConfigurationSteps.some(desktopOnlyRegex => desktopOnlyRegex.test(state)));
};
